export const TopicMetadata = {
    "1-1": "自作のテキスト",
    "1-2": "先生を偲ぶ",
    "1-3": "親に子を預けて母親が旅行へ",
    "1-4": "だからよー",
    "1-5": "物忘れ",
    "1-6": "きじむなー (木の精)",
    "1-7": "かくれんぼ",
    "1-8": "石なーぐー (石なご)",
    "1-9": "子守の時の失敗談",
    "1-10": "ハワイのおじいさん",
    "1-11": "皆で普及活動を楽しむ",
    "1-12": "しばいを取り入れた うちなーぐち教授法",
    "1-13": "県のテスト",
    "2-1": "はちあっちー  (初歩き)",
    "2-2": "四日じーるー  (出産後の儀式)",
    "2-3": "まんさん  (誕生祝い)",
    "2-4": "まーすでー (出産祝い)",
    "2-5": "笑い方を注意される",
    "2-6": "男性上位の志向",
    "2-7": "ひさくーてぃ (相手を責めない表現)",
    "2-8": "そーみん いりちー",
    "2-9": "ステーキ「カーボーイ」",
    "2-10": "胎盤",
    "2-11": "たんかーすーじ (満一歳の祝い)",
    "2-12": "はちむーちー (初むーちー)",
    "2-13": "うーじとーしー (さとうきびの収穫)",
    "3-1": "長音表記",
    "3-2": "漢字での表記",
    "3-3": "うちなーぐちの語彙数",
    "3-4": "うちなーぐち普及に関する条例",
    "3-5": "文法",
    "3-6": "勉強会: 博物館の講座",
    "3-7": "民話",
    "3-8": "うちなーぐちの使用",
    "3-9": "久茂地のことば",
    "3-10": "地域差",
    "3-11": "二人称代名詞の敬称",
    "3-12": "二人称代名詞「なー」",
    "3-13": "残す言葉",
    "4-1": "新じゃがはおいしい！",
    "4-2": "トラクターの車庫入れ",
    "4-3": "トラクターを通常道路で走行",
    "4-4": "野菜作り",
    "4-5": "痛風はこわいが、ビールはおいしい",
    "4-6": "昔のトマトと今のトマト",
    "4-7": "「ぬーそーが」は挨拶",
    "4-8": "しーさー",
    "4-9": "さしみ屋の話",
    "4-10": "包丁の話",
    "5-1": "はーりー船を漕いだ",
    "5-2": "甘菓子",
    "5-3": "手作り甘菓子",
    "5-4": "首里城の火災",
    "5-5": "二人の龍潭の思い出",
    "5-6": "ギネスブック級の大綱",
    "5-7": "識名小学校においての普及活動",
    "5-8": "普及活動の限界",
    "5-9": "給食: ミルク",
    "5-10": "クラブ活動",
    "5-11": "幼稚園においての活動",
    "5-12": "方言札を再現",
    "5-13": "家庭のしつけ",
    "5-14": "「いちゃりばちょーでー 」の博愛精神",
    "5-15": "やーなれーどぅふかなれー(躾の一歩は家庭から)１",
    "5-16": "やーなれーどぅふかなれー(躾の一歩は家庭から)２",
    "5-17": "義母の賛辞",
    "5-18": "技術の進歩",
    "6-1": "コロナによる失業",
    "6-2": "コロナと観光客",
    "6-3": "コーヒー",
    "6-4": "島くとぅばの日のパレード",
    "6-5": "パレードでの格好",
    "6-6": "間切り内での結婚",
    "6-7": "志喜屋語",
    "6-8": "都落ちした士族の部落",
    "6-9": "島腐らし",
    "6-10": "大晦日の肉料理",
    "6-11": "神酒",
    "6-12": "初穂を捧げる儀式",
    "6-13": "十三歳と十五歳成人としての社会貢献",
    "7-1": "「若い」と言われて嬉しい",
    "7-2": "うちなーぐち：昔と今",
    "7-3": "「ちむ（肝）とくくる（心）」",
    "7-4": "子供と大人の学習態度比較",
    "7-5": "子供の頃の思い出：お年寄りとの交わり",
    "7-6": "子供のしつけ：昔と今の比較",
    "7-7": "言葉もお金も大切に",
    "7-8": "親の目には子供はいつまでも子供",
    "7-9": "「かわいそう」≠「ちむぐりさん」",
    "7-10": "民謡クラブへのお年寄の送迎",
    "7-11": "道くんまーち（遠回り）",
    "7-12": "しーぶんぐわー（おまけ）",
    "7-13": "まちぐゎーの人とのつながり",
    "7-14": "「ちむ(肝・心)」の入る表現",
    "7-15": "NHK朝ドラでのうちなーぐち使用",
    "7-16": "ちむうらーきーん(心を落ち着かせる)",
    "7-17": "ちむぶとぅみち(心のときめき)",
    "8-1": "疎開船の中の猛暑",
    "8-2": "疎開先での黒砂糖の効用",
    "8-3": "やーさん ひーさん しからーさん (ひもじい 寒い さびしい)",
    "8-4": "戦後配給米の「っんなび 」",
    "8-5": "チーズに出会った時の思い出",
    "8-6": "屑鉄集めのアルバイト",
    "8-7": "沖縄の富の共有精神",
    "8-8": "手作り遊具",
    "8-9": "しーぐ(ナイフ)",
    "8-10": "みくしうがなびら(首里殿内での作法)",
    "8-11": "挨拶：ちゅう うがなびら",
    "8-12": "古典芸能における言葉の重要性",
    "8-13": "見えなくなった沖縄の生き物",
    "8-14": "使い捨ての時代",
    "8-15": "少子化の時代",
    "9-1": "やぎの歌うちなーぐちバージョン",
    "9-2": "父親の農業一番の哲学",
    "9-3": "家庭訪問における父親と先生の会話",
    "9-4": "進学に関する親の意見",
    "9-5": "学費稼ぎのアルバイト",
    "9-6": "うちなーぐちロボット",
    "9-7": "うちなーぐち話者の減少",
    "9-8": "うちなーぐちで建築を教えたいとの願い",
    "9-9": "茅葺き屋根",
    "9-10": "竹葺き屋根",
    "9-11": "経済学のうちなーぐちは「すーてー」",
    "9-12": "演歌をうちなーぐちで歌う",
    "9-13": "ハワイの若者のCDを紹介",
    "9-14": "「ぬちどぅ宝」(命こそが最大の宝)",
    "10-1": "沖縄語普及協議会の立ち上げ",
    "10-2": "ウチナーンチュ大会",
    "10-3": "第4回ウチナーンチュ大会交流会",
    "10-4": "小学校でのクラブ活動",
    "10-5": "幼稚園での取り組み",
    "10-6": "沖縄ハンズオンの取り組み",
    "10-7": "大切な敬い言葉",
    "10-8": "うちなーぐち習におけるスマホの活用",
    "10-9": "大人に尊敬語を教える",
    "10-10": "真和志高校福祉課程でのうちなーぐち",
    "10-11": "介護のうちなーぐち"
}

